export const CENTER = { x: 50, y: 50 };
export const BOUNDARY_RADIUS = 48;
export const TOTAL_SLICES = 48;
export const SLICE_ANGLE = 360 / TOTAL_SLICES; // 7.5
// Canonical RADIAL_BANDS lives in ./radialBands.js — import from there.
